import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { store } from './data-layer/store';
import { Notifications } from './routing/notifications/Notifications';
import { routes } from './routing/routes';
import { setupAxiosInterceptors } from './setupAxiosInterceptors';
import { MessengerWidgetProvider } from './ui/business/MessengerWidget';
import { VideoPlayerProvider } from './utils/VideoPlayerProvider';
import { InvariantProvider } from './utils/withInvariant';

setupAxiosInterceptors('app');

window.history.scrollRestoration = 'manual';

type GetElement = (isHydrated: boolean) => ReactElement;

function getRenderer(container: HTMLElement) {
    if (container.children.length === 0) {
        const root = ReactDOM.createRoot(container);

        return (getElement: GetElement) => root.render(getElement(false));
    }

    return (getElement: GetElement) => ReactDOM.hydrateRoot(container, getElement(true));
}

const container = document.getElementById('root') as HTMLElement;
const browserRouter = createBrowserRouter(routes, {
    basename: process.env.REACT_APP_BASE_PATHNAME,
});

getRenderer(container)((isHydrated: boolean) => (
    <InvariantProvider isHydrated={isHydrated}>
        <VideoPlayerProvider>
            <MessengerWidgetProvider guid={process.env.REACT_APP_MESSENGER_CHAT_GUID}>
                <Provider store={store}>
                    <RouterProvider router={browserRouter} />
                    <Notifications />
                </Provider>
            </MessengerWidgetProvider>
        </VideoPlayerProvider>
    </InvariantProvider>
));
